import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { INSTAGRAM_URL } from '../utils/links';
import logo from '../images/logo_zave.png';
import './Footer.css';

function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <img src={logo} alt="Transportes ZAVE SpA" className="footer-logo" />
        <p className="footer-brand">{t('footer.brand')}</p>
        <p className="footer-location">{t('footer.location')}</p>
        <p className="footer-schedule">{t('footer.schedule')}</p>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-instagram"
          aria-label="Instagram ZAVE Transportes"
        >
          Instagram
        </a>
        <p className="footer-copy">
          © {new Date().getFullYear()} {t('footer.brand')}. {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
